import { z } from 'zod/v4';

import { crashLogItemSchema } from './crash-log-item.schema';

export const crashLogResponseSchema = z.object({
  message: z.string(),
  timestamp: z.string(),
  items: z.array(crashLogItemSchema),
  itemsFound: z.number(),
  requestedItems: z.number(),
});

export type CrashLogResponse = z.infer<typeof crashLogResponseSchema>;
